import * as React from "react";
import { FC, useState } from "react";
import { useHistory } from 'react-router-dom';
interface Props {}
export const NewContent: FC<Props> = () => {
  let {location, push} = useHistory();
  const {DeviceID, ap, band, campaign, search, survey_ids, token, threshold} = location;

  return ( 
    <div>
        <img
            className="img-fluid w-100"
            src={campaign.newsID.urlToImage}
            alt="img"
        />

        <div className="row w-100 pb-2 m-0 p-1">
  <h4>{campaign.newsID.title}</h4>
        </div>
    
        <div className="row w-100 m-0">
            {campaign.newsID.content}
        </div>

        <div className="row w-100 pt-1 m-0 p-2">
          <button className="btn btn-primary w-100 m-2" onClick={() => push("/content", {
             campaign: campaign,
             DeviceID,
             ap,
             band,
             survey_ids,
             search: search,
             token: token,
             threshold
          })}>
            Continuar {" >>"}
          </button>
      </div>
    </div>
  ) 

}